module.exports = __webpack_public_path__ + "static/Squarespace-f2345ead6887d15e515e35ba0e63b14c.jpg";